import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Button } from '../../Button/index.js';
import { formatClassName as _formatClassName } from '../../../utils/formatClassName.js';
var _excluded = ["label", "selected", "highlighted"];

var FilterButton = function FilterButton(_ref) {
  var label = _ref.label,
      selected = _ref.selected,
      highlighted = _ref.highlighted,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Button, _extends({
    className: _formatClassName({
      selected: highlighted,
      'filter-button': true,
      'ui-default': true
    }),
    label: selected !== true && selected || label,
    rightIcon: "angle-down",
    style: "elevated"
  }, rest));
};

FilterButton.displayName = "FilterButton";
export { FilterButton };